module.exports = __webpack_public_path__ + "static/media/d2.fd5a05b0.m4a";